// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link as RouterLink } from 'react-router-dom';

// local
import styles from './Link.pcss';

// todo: default text-only children to underlined
export default class Link extends PureComponent {
  
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    download: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.shape(),
    title: PropTypes.string,
    to: PropTypes.string,
  }
  static defaultProps = {
    onClick: () => {},
  }
  
  wrap = (content) => {
    const { children, className, download, onClick, to, title } = this.props;
    
    const classes = classnames(className, styles.link, {
      [styles.text]: (typeof children === 'string'),
    });
        
    if (!to) {
      return (
        <div
          className={ classes }
          title={ title }
          onClick={ onClick }
          style={ this.props.style }
          children={ content } />
      );
    }
    // is local
    return /^[/#]/.test(to)
      ? (
        <RouterLink
          className={ classes }
          download={ download }
          title={ title }
          style={ this.props.style }
          onClick={ onClick }
          to={ to }
          children={ content } />
      )
      : (
        <a
          className={ classes }
          download={ download }
          href={ to }
          children={ content }
          onClick={ onClick }
          style={ this.props.style }
          target={ '_blank' }
          title={ title }
          rel={ 'noopener noreferrer' }  />
      );
  }
  
  render() {
    const { children } = this.props;
    return this.wrap(children);
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Link/index.jsx